<template>
    <section>
        <page-header>
            <slot slot="title">{{ $t('customer_users.title') }}</slot>
        </page-header>
        <section class="[ c-filters-parent ] o-page-row--medium c-filters-parent--white">
            <div class="u-flex [ o-wrapper o-wrapper--center ]">
                <v-customer-search :impersonate=false @selected="setUser" @clear="clear" :preSearch="Customer.Name"></v-customer-search>
                <v-input 
                    v-model="keyword"
                    :placeholder="$t('customer_users.enter_term')">
                </v-input>
                <button class="c-button c-button--alpha" @click="search">{{ $t('global.search') }}</button>
            </div>
        </section>
        <div class="o-wrapper o-wrapper--center">
            <section class="o-page-row--medium">
                <v-loading :data="loaded"></v-loading>
                <table-component v-if="Users.length" class="o-page-row" table-class="c-table c-table--small"
                                    :data="Users" :show-caption="false" :show-filter="false">
                    <table-column key="LastName" :label="$t('customer_users.columns.last_name')" :sortable="false">
                        <template slot-scope="row">
                            {{row["LastName"]}}
                        </template>
                    </table-column>
                    <table-column key="FirstName" :label="$t('customer_users.columns.first_name')" :sortable="false">
                        <template slot-scope="row">
                            {{row["FirstName"]}}
                        </template>
                    </table-column>
                    <table-column key="Email" :label="$t('customer_users.columns.email')" :sortable="false">
                        <template slot-scope="row">
                            {{row["Email"]}}
                        </template>
                    </table-column>
                    <table-column key="Role" :label="$t('customer_users.columns.role')" :sortable="false">
                        <template slot-scope="row">
                            {{row["Role"]}}
                        </template>
                    </table-column>
                    <table-column key="Function" :label="$t('customer_users.columns.function')" :sortable="false">
                        <template slot-scope="row">
                            <span v-if="row.Function === 1">Strateeg</span>
                            <span v-else>Zaakvoerder</span>
                        </template>
                    </table-column>
                    <table-column cell-class="u-text-nowrap" :label="$t('customer.account.users.columns.blocked')" :sortable="false" :filterable="false">
                        <template slot-scope="row">
                            <div class="o-spacing-tiny">
                                <v-switch v-model="row.IsBlocked" name="blocked" @input="blockUser(row.CustomerId, row.Id, row.IsBlocked)"></v-switch>
                            </div>
                        </template>
                    </table-column>
                </table-component>
                <div v-else class="u-font-large u-text-align-center u-padding">
                    Geen gebruikers gevonden<br>
                    <span class="u-font-default">Fout in de pagina? Neem contact op met de administrator.</span>
                </div>
            </section>
        </div>
    </section>
</template>

<script>
    import Vue from "vue";
    import PageHeader from "@/components/common/PageHeader";
    import VInput from '@/components/form/Input';
    import VSwitch from '@/components/form/Switch';
    import VCustomerSearch from '@/components/form/customerSearch/CustomerSearch';
    import VLoading from '@/components/Loading'

    // store
    import {mapGetters} from "vuex";

    export default {
        components: {
            PageHeader,
            VInput,
            VSwitch,
            VCustomerSearch,
            VLoading
        },
        data() {
            return {
                customerKey: 0,
                keyword: '',
                loaded: {}
            }
        },
        props: {},
        created() {
            this.loaded = {};
            let filter = {};
            if(this.$route.query.customerKey) {
                filter.customerKey = this.$route.query.customerKey;
                this.customerKey = this.$route.query.customerKey;

                this.$store.dispatch("getCustomerById", this.$route.query.customerKey);
            }
            if(this.$route.query.keyword) {
                filter.keyword = this.$route.query.keyword;
                this.keyword = this.$route.query.keyword;
            }
            
            this.$store.dispatch("searchUsers", filter).then(() => {
               this.loaded = { isLoaded: true };
            });
        },
        computed: {
            ...mapGetters({
                Users: "Users",
                Customer: "Customer"
            })
        },
        methods: {
            fetchData(customerKey, keyword) {
                this.loaded = {};

                let filter = {};
                if(customerKey) {
                    filter.customerKey = customerKey;
                }
                if(keyword) {
                    filter.keyword = keyword;
                }
                
                this.$store.dispatch("searchUsers", filter).then(() => {
                    this.loaded = {isLoaded: true};
                });
            },
            search() {
                this.fetchData(this.customerKey, this.keyword);
                this.$router.push({ path: this.$route.path, query: { keyword: this.keyword, customerKey: this.customerKey } });
            },
            blockUser(customerId, id, state) {
                this.$store.dispatch('blockCustomerUser', {
                    id: customerId,
                    userId: id,
                    body: {
                        IsBlocked: state
                    }
                });
            },
            setUser(user) {
                this.customerKey = user.Id;
                this.Customer.Name = user.Name;
            },
            clear() {
                this.customerKey = null;
                this.Customer.Name = '';
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .c-customer-search {
        padding: 0;
        background-color: transparent;
    }
</style>    


// WEBPACK FOOTER //
// src/views/salesman/customerList/CustomerUsers.vue